import {
  productTypeAccessory,
  productTypeCombo,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { ToastTypeError, ToastTypeInfo } from "../../stores/slices/toastSlice";

export const en = {
  translation: {
    aoda: {
      buttonLabel: {
        addCustomPart: "Button to add custom part",
        addLineItemToCart: "Button to add line item to cart",
        addToQuote: "Button to add to quote",
        addVehicles: "Add vehicles",
        backToQuote: "Button to go back to quote",
        backToSearchResults: "Button to go back to search results",
        backToStore: "Button to go back to store",
        backToSubmodelList: "Back to Submodel List",
        calculatorMode: "Button to switch calculator mode",
        cancelPasswordReset: "Button to cancel password reset",
        carouselControl: "Button to select carousel item",
        checkNationalStock: "Button to check national stock",
        checkNationalStockRear: "Button to check national stock for rear",
        clearCartAndContinue: "Button to clear cart and continue",
        clearCriteria: "Button to clear criteria",
        clearTireSizeInput: "Button to clear tire size input",
        closeDialog: "Button to close dialog",
        closeErrorToast: "Button to close error toast",
        closeFiltersPanel: "Button to close filters panel",
        closeInfoToast: "Button to close info toast",
        closeSignInDialog: "Button to close sign in dialog",
        closeSignUpDialog: "Button to close sign up dialog",
        closesNewQuoteDialog: "Button to close new quote dialog",
        closesOrderDialog: "Button to close order dialog",
        contactDealerSubmitButton: "Button to submit contact dealer form",
        contactDealerSuccessButton: "Button to contact dealer again",
        copyPackage: "Button to copy package",
        createNewQuote: "Button to create new quote",
        createPackage: "Button to create package",
        dealerGroupLogo: "Dealer group logo",
        deletePackage: "Button to delete package",
        editPackage: "Button to edit package",
        hamburder: "Main menu button",
        homepageLink: "Button to go back to homepage",
        leadFormPrimaryAction: "Primary lead form action button",
        leadFormSecondaryAction: "Secondary lead form action button",
        moreResults: "Button to load more results",
        myLeadsTabButton: "Button to open my leads tab",
        myOrdersTabButton: "Button to open my orders tab",
        myQuotesTabButton: "Button to open my quotes tab",
        openBookingSystem: "Button to open booking system in a new window",
        openCMS: "Button to open CMS in a new window",
        openCartPreview: "Button to open cart preview",
        openDealerContactForm: "Button to open dealer contact form",
        openDownloadDialog: "Button to open download dialog",
        openEmailDialog: "Button to open email dialog",
        openFiltersPanel: "Button to open filters panel",
        openHowtoVideos: "Button to open how to videos in a new window",
        openMyLeadsDialog: "Button to open my leads dialog",
        openMyOrderDialog: "Button to open my order dialog",
        openMyQuotesDialog: "Button to open my quotes dialog",
        openOrderDialog: "Button to open order dialog",
        openPackageEditor: "Open Package Editor",
        openPrintDialog: "Button to open print dialog",
        openSearchResultsInANewWindow:
          "Button to open search results in a new window",
        openSignInDialog: "Button to open sign in dialog",
        openTireCompareDialog: "Button to open tire compare dialog",
        openUserMenu: "Button to open user menu",
        placeOrder: "Button to place order",
        pricingAnalysisSearch: "Button to search pricing analysis entries",
        quoteAction: "Quote action button",
        removeFromCompare: "Button to remove from compare",
        removeFromQuote: "Button to remove from quote",
        removeItemFromCart: "Button to remove item from cart",
        removeLineItemFromCart: "Button to remove line item from cart",
        resetLeadForm: "Button to reset lead form",
        saveQuote: "Button to save quote",
        searchByChassis: "Button to search by chassis",
        searchByPartNubmer: "Button to search by part number",
        searchByTireSize: "Button to search by tire size",
        searchByVehicle: "Button to search by vehicle",
        searchDealers: "Button to search dealers",
        selectAllVehicles: "Button to Select All Vehicles",
        selectNoneVehicles: "Button to Select None Vehicles",
        selectSeason: "Button to select season",
        selectSubmodel: "Button to select submodel",
        selectTireSize: "Button to select tire size",
        selectYear: "Button to select year",
        sendRequest: "Button to send request",
        showBookAppointmentDialog: "Button to show book appointment dialog",
        showCalclator: "Button to show calculator",
        showEmailField: "Button to show email field",
        showMap: "Button to show map",
        showNewQuoteModal: "Button to show new quote dialog",
        showParts: "Button to show parts",
        showTelField: "Button to show telephone number field",
        signOut: "Button to sign out",
        stockRecordLink: "Link to stock record",
        submitDealerForm: "Button to submit dealer form",
        submitPasswordresetForm: "Button to submit password reset form",
        submitSignInForm: "Button to submit sign in form",
        submitSignupForm: "Button to submit sign up form",
        tireStockToggle: "Toggle tire stock",
        toastAction: "Button to perform action",
        togglePackageDetails: "Button to toggle package details",
        toggleTireCompare: "Button to toggle tire compare",
        vehicleColour: "Button to select vehicle colour",
        viewDetails: "Button to view details",
        viewResults: "Button to view results",
        viewTireSizeDiagram: "Button to view tire size diagram",
        visitDealerPage: "Button to visit dealer page",
      },
      inputLabel: {
        advancedPricing: "Advanced Pricing",
        appointmentTime: "Appointment time",
        brandFilter: "Brand filter",
        clickToSelectFile: "Click to select file",
        criteria: "Search criteria",
        customPartName: "Custom Part Name",
        customPartNameFr: "Custom Part Name (French)",
        customPartNumber: "Custom Part Number",
        customPartPrice: "Custom Part Price",
        customTypeName: "Custom Type Name",
        customTypeNameFr: "Custom Type Name (French)",
        dateFilter: "Date filter",
        distance: "Distance",
        financeAmount: "Finance Amount",
        financeInterest: "Finance Interest",
        financePayment: "Finance Payment",
        financeTerm: "Finance Term",
        packageDescription: "Package Description",
        packageImage: "Package Image",
        packageName: "Package Name",
        packageNumber: "Package Number",
        packagePrice: "Package Price",
        partNumber: "Part Number",
        poNumber: "Purchase Order Number",
        postalCode: "Postal Code",
        provinceFilter: "Province filter",
        quantity: "Quantity",
        quoteTotal: "Quote Total",
        seasonFilter: "Season filter",
        selectedChassis: "Selected Chassis",
        selectedDate: "Selected Date",
        selectedDealer: "Selected Dealer",
        selectedModel: "Selected Model",
        selectedProductType: "Selected Product Type",
        selectedQuantity: "Selected Quantity",
        selectedTireSize: "Selected Tire Size",
        selectedTrim: "Selected Trim",
        sizeFilter: "Size filter",
        sortSelect: "Sort select",
        tireSize: "Tire Size",
        username: "Username",
        vehicleManufacturerName: "Vehicle Manufacturer Name",
        vehicleYear: "Vehicle Year",
        yourEmail: "Your email",
        yourFirstName: "Your first name",
        yourLastName: "Your last name",
        yourNotes: "Your notes",
        yourPassword: "Your password",
        yourPasswordConfirm: "Reenter your password",
        yourPhone: "Your phone number",
      },
      pageTitle: {
        ACCESSORIES: "Accessories",
        ALLOY_WHEELS: "Alloy Wheels",
        PACKAGES: "Packages",
        TIRES: "Tires",
        dealerCartPage: "Cart",
        dealerComparePrintPage: "Print Tire Compare",
        dealerContactUsPage: "Contact Us",
        dealerHomePage: "Homepage",
        dealerProductDetailsPage: "Product Info",
        dealerResultsPage: "Search Results",
        dealerWishlistPrintPage: "Print Cart",
        nationalVendorLandingPage: "Fitting Room",
        nationalVendorPage: "Dealer Search",
        packageEditor: "Package Editor",
      },
    },
    auth: {
      accountCreated: "Account created. Please sign in.",
      cancel: "Cancel",
      createAccount: "Create Account",
      failedToSignIn: "Failed to sign in, please try again.",
      forgotPassword: "Forgot Password?",
      lickToRegister: "Click to Register",
      myLeads: "My Leads",
      myOrders: "My Orders",
      myQuotes: "My Quotes",
      passwordReset: "Password Reset",
      reset: "Reset",
      signIn: "Sign In",
      signInTitle: "Welcome Back",
      signUp: "Sign Up",
    },
    calculator: {
      bWeekly: "Bi-Weekly",
      error: {
        positiveInteger: "The term should be a whole number (no decimals).",
        positiveNumber: "Please enter a number that is 0 or more.",
      },
      month_one: "Month",
      month_other: "Months",
      monthly: "Monthly",
      placeHolderAmount: "Finance Amount",
      placeholderInterest: "Interest Rate",
      placeholderMonths: "# of Months",
      placeholderWeeks: "# of Weeks",
      week_one: "Week",
      week_other: "Weeks",
    },
    captcha: {
      robotCheck: "Robot Check",
    },
    cart: {
      add: "Add",
      addItem: "Add Item",
      addToQuote: "Add to Quote",
      address: "Address",
      appointmentRequestDisclaimer:
        "The appointment request is only a request and not a confirmed appt – Our service department will contact you within 24 hours to confirm an appointment.",
      backToStore: "Back to Store",
      bookAppointment: "Book Appointment",
      cancel: "Cancel",
      contactDealer: "Contact Dealer",
      contactDealerForPricing: "Contact Dealer for Pricing",
      contactInformation: "Contact Information",
      continue: "Continue",
      createNewQuote: "Create a new Quote",
      customerEmail: "Customer Email",
      customerName: "Customer Name",
      customerNotes: "Customer Notes",
      customerPhone: "Customer Phone",
      date: "Date",
      dealerAddress: "Dealer Address",
      dealerEmail: "Dealer Email",
      dealerName: "Dealer Name",
      dealerPhone: "Dealer Phone",
      generateQuote: "Generate Quote",
      header: { order: "Your Order", quote: "Your Personalized Quote" },
      newQuote: "New Quote",
      newQuoteModalContent:
        "You will be directed to start a new shopping session.",
      noOrders: "No orders here, try adding some!",
      notAvailable: "N/A",
      notes: "Notes",
      ok: "OK",
      orderCreatedTimestamp: "Created at",
      orderCreatedUserName: "Created by",
      orderNow: "Order Now",
      packageCreatedMessage: "Tires in cart. Please choose wheels next.",
      price: "Price",
      quantity: "Quantity",
      reference: "Reference",
      remove: "Remove",
      removeFromQuote: "Remove from Quote",
      requestAppointment: "Request Appointment",
      saveQuote: "Save Quote",
      subtotal: "Subtotal",
      tax: "Tax",
      thankYourForChoosing: "Thank you for choosing",
      timeOptions: {
        am: "AM",
        pm: "PM",
      },
      total: "Total",
      totalPrice: "Total Price",
      viewDetails: "View Details",
      xTimeAppointmentDialogSubtitle:
        "Appointment Schedule - To ensure tires availability, please book appointment 24 hours from today.",
      xTimeAppointmentDialogTitle: "Book Appointment",
      xTimeAppointmentHeadline: "Pick an appointment time with {{dealerName}}",
      xTimeAppointmentNodata: "Failed to load the appointment form",
      yourOrder: "Your Order",
      yourQuote: "Your Quote",
    },
    compare: {
      additionalCosts: "Additional Costs",
      category: "Category",
      clientInformation: "Client Information",
      description: "Description",
      frontPartNumber: "Front Part #",
      grandTotal: "Grand Total",
      mileageWarranty: "Mileage Warranty",
      moreInfo: "More Info",
      msrp: "MSRP",
      natPart: "Nat Part #",
      notAvailable: "N/A",
      originalEquipment: "Original Equipment",
      otherInformation: "Other Information",
      ourPrice: "Our Price",
      partNumber: "Part #",
      pricingDetails: "Pricing Details",
      pricingInformation: "Pricing Information",
      productDetails: "Product Details",
      productInformation: "Product Information",
      promotion: "Promotion",
      quantity: "Quantity",
      quick: "Quick Compare",
      rearPartNumber: "Rear Part #",
      season: "Season",
      selected: "Compare Selected",
      subtotal: "Subtotal",
      tax: "Tax",
      tireSize: "Tire Size",
      total: "Total",
      warranty: "Warranty",
    },
    contactUs: {
      address: "Address",
      closed: "Closed",
      email: "Email",
      header: "Contact Us",
      home: "Home",
      hoursHeader: "{{dealerName}} Customer Service",
      hoursSubtitle: "Our Business Hours",
      phone: "Phone",
    },
    dealerOrderModal: {
      contactInformation: "Contact Information",
      customerNumber: "Customer#",
      delivery: "Delivery",
      disclaimer:
        "Tire Wizard Inc. is not responsible for order fulfilment. For any changes or questions regarding your order please contact TireLink Directly.",
      email: "Email",
      emailPlaceholder: "Enter email here",
      error: {
        customerEmail: "Please enter a valid email address",
        invalidResponse: "Order failed. Please contact your dealer.",
        poNumber: "Please enter a PO number",
      },
      errorMessage: "We apologize but we failed to receive the proper data",
      estDeliveryDate: "Est. Delivery Date",
      firstName: "First Name",
      firstNamePlaceholder: "Enter first name here",
      freight: "Freight",
      itemInformation: "Item Information",
      lastName: "Last Name",
      lastNamePlaceholder: "Enter last name here",
      loadSpeedPly: "Load/Speed/Ply",
      local: "Local",
      "local+": "Local+",
      locationCode: "Location Code#",
      natPart: "Nat Part",
      national: "National",
      nationalPricing: "NAT",
      noData: "Sorry, you don't have any order items.",
      orderPreview: "Order Preview",
      paymentQty: "Payment Qty",
      phone: "Phone",
      phonePlaceholder: "Enter phone number here",
      pickUp: "Pick Up",
      placeOrder: "Place Order",
      poPlaceholder: "Enter PO number",
      quantity: "{{from}} of {{to}}",
      remove: "Remove",
      sourcedQty: "Sourced Qty",
      subtotal: "Subtotal",
      successMessage: "Order confirmed. ID #{{orderNumber}}.",
      tireSize: "Tire Size",
      total: "Total",
      unitCost: "Unit Cost",
      withOtherGoods: "With Other Goods",
    },
    dealerProducts: {
      [productTypeAccessory]: "Accessories",
      [productTypeCombo]: "Wheel + Tire",
      [productTypePackage]: "Packages",
      [productTypeTire]: "Tires",
      [productTypeWheel]: "Wheels",
    },
    dealerTireTile: {
      availableStock: "Available Stock",
      compare: "Compare",
      createPackage: "Create Package",
      inLocation_one: " in {{count}} location",
      inLocation_other: "in {{count}} locations",
      mostPopular: "Most Popular",
      other: "Other",
      tires_one: "{{displayCount}} Tire",
      tires_other: "{{displayCount}} Tires",
    },
    error: {
      boundary: {
        heading: "Something went flat",
        message: "Back on track soon",
      },
    },
    form: {
      error: {
        appointmentRequestDate: "Please select a date",
        appointmentRequestTime: "Please select a time",
        customName: "Please enter a custom name",
        customNameFr: "Please enter a custom name (French)",
        customPartNumber: "Please enter a custom part number",
        customPrice: "Please enter a price",
        customTypeName: "Please enter a custom type name",
        customTypeNameFr: "Please enter a custom type name (French)",
        customerEmail: "Please enter a valid email address",
        customerFirstName: "Please enter your first name",
        customerLastName: "Please enter your last name",
        customerPhone: "Please enter a valid phone number",
        email: "Please enter a valid email address",
        invalidDate: "Please enter a valid date",
        lineItemNotes: "Please enter a note",
        lineItemPrice: "Please enter a discount",
        name: "Please enter your name",
        packageDescription: "Please enter a package description",
        packageName: "Please enter a package name",
        packageNumber: "Please enter a package number",
        packagePrice: "Please enter a package price",
        packageQuantity: "Please enter a quantity between 1 and 16",
        partNumber: "Please enter a part number",
        password: "Please enter your password",
        passwordMismatch: "Passwords do not match",
        postalCode: "Postal code must be a valid US or Canadian postal code",
        pricePrecision: "Price must have up to 2 decimal places.",
        tel: "Please enter a valid phone number",
        tireSize: "Please enter tire size",
        username: "Please enter a valid email address",
        vehicleManufacturerIds: "Please select a manufacturer",
        vehicleYearIds: "Please select a year",
      },
      label: {
        add: "Add",
        appointmentRequestDate: "Preferred Appointment Date",
        appointmentRequestTime: "Preferred Contact Time",
        cancel: "Cancel",
        customerEmail: "Customer Email",
        discount: "Discount",
        email: "Email",
        firstName: "First Name",
        lastName: "Last Name",
        name: "Name",
        note: "Message (Note)",
        notes: "Notes",
        optionalMessage: "Message (Optional)",
        password: "Password",
        passwordConfirm: "Confirm Password",
        phoneNumber: "Phone Number",
        priceMatchNotes: "Price Match Notes",
        tel: "Phone",
        username: "Email Address",
        workOrderNumber: "Work Order Number",
      },
      placeholder: {
        email: "Enter email",
        firstName: "Enter your first name",
        lastName: "Enter your last name",
        name: "Enter name",
        notes: "Enter notes here",
        optionalMessage: "Enter message",
        password: "Enter password here",
        phoneNumber: "Enter your phone number",
        tel: "Enter phone number",
        username: "Enter email here",
      },
    },
    header: {
      contactUs: "Contact Us",
    },
    heroWheels: {
      guarantee: "Guarantee",
      lowestPrice: "Lowest Price",
      tireSource: "Tire Source",
    },
    leadForm: {
      button: {
        download: {
          primary: "Download & Email",
          secondary: "Download",
        },
        email: {
          primary: "Send",
        },
        print: {
          primary: "Print & Email",
          secondary: "Print",
        },
        "save-quote": {
          primary: "Save Quote",
        },
      },
      compare: {
        subtitle: {
          download: "Fill in the form below to dowload this comparison.",
          email: "Fill in the form below to send this comparison.",
          print: "Fill in the form below to print this comparison.",
        },
        title: {
          download: "Download",
          email: "Email",
          print: "Print",
        },
      },
      download: "Download",
      email: "Email",
      order: {
        subtitle: {
          download: "Download order as PDF and optionally send an email.",
          email: "Fill in form to email customer this order.",
          print: "Print your order and optionally send an email.",
        },
        title: {
          download: "Download Order",
          email: "Email Order",
          print: "Print Order",
          save: "Save Order",
        },
      },
      print: "Print",
      quote: {
        subtitle: {
          download: "Download quote as PDF and optionally send an email.",
          email: "Fill in form to email customer this quote.",
          print: "Print your quote and optionally send an email.",
        },
        title: {
          download: "Download Quote",
          email: "Email Quote",
          print: "Print Quote",
          save: "Save Quote",
        },
      },
      successMessage: "Your request has been sent.",
    },
    leadReport: {
      createdDate: "Date Created (Updated)",
      customerEmail: "Customer Email",
      customerName: "Customer Name",
      customerNotes: "Notes",
      customerPhone: "Customer Phone",
      generatedByActionType: "Type",
      noData: "Sorry, your search was unable to find any results.",
      orderId: "Quote #",
      ownerType: "Type",
      requestedDate: "Requested Date",
      status: "Order Status",
    },
    national: {
      anyDistance: "Any Distance",
      contactDealerForPricing: "Contact Dealer for Pricing",
      dealer: "Dealer",
      location: "Location",
      nodata: "Sorry, your search was unable to find any results.",
      phone: "Phone",
      postalCodeOrCity: "Postal Code or City",
      redirecting: "Redirecting...",
      search: "Search",
      selectDealerForPricing: "Select dealer for pricing",
      selectDealership: "Select Dealership",
      showMap: "Show Map",
      withinDistance: "Within {{option}} Km",
    },
    orderFilters: {
      "1month": "1 Month",
      "2months": "2 Months",
      "3months": "3 Months",
      "4months": "4 Months",
      "7days": "7 Days",
      all: "All",
      byCreatedAscending: "By Created Ascending",
      byCreatedDescending: "By Created Descending",
      byCustomerNameAscending: "By Customer Name Ascending",
      byCustomerNameDescending: "By Customer Name Descending",
      byLeastRecent: "By Least Recent",
      byMostRecent: "By Most Recent",
      byTotalPriceAscending: "By Total Price Ascending",
      byTotalPriceDescending: "By Total Price Descending",
      search: "Search",
      show: "Show",
      size: "Limit",
      sort: "Sort",
      today: "Today",
      typeToSearch: "Type to Search",
      yesterday: "Yesterday",
    },
    orderReport: {
      confirmationNumber: "Confirmation Number",
      createdBy: "Created By",
      customerEmail: "Customer Email",
      customerName: "Customer Name",
      customerNotes: "Notes",
      customerPhone: "Customer Phone",
      dateCreated: "Date Created (Updated)",
      deliveryStatus: "Delivery Status",
      orderNumber: "Order #",
      orderTotal: "Order Total",
      poNumber: "PO Number",
      type: "Type",
      viewOrders: "View Order",
    },
    packageEditor: {
      actionsDetails: "Actions/Details",
      addCustomPart: "Add Custom Part",
      addVehicles: "Add vehicles",
      advancedPricing: "Advanced Pricing",
      brandIcon: "Brand Icon",
      close: "Close",
      copyPackage: "Copy Package",
      cost: "Cost",
      createPackage: "Create Package",
      createQuote: "Create Quote",
      customName: "Name (English)",
      customNameFr: "Name (French)",
      customPrice: "Price",
      customTypeName: "Type (English)",
      customTypeNameFr: "Type (French)",
      deletePackage: "Delete Package",
      edit: "Edit",
      editPackage: "Edit Package",
      fetchVehicles: "Fetch Vehicles",
      info: "Info",
      invalidQuoteNotice:
        "Please add at least one part to the quote to create a package.",
      myPrice: "My Price",
      nationalSuggestedRetail: "National Suggested Retail",
      newPackage: "New Package",
      next: "Next",
      noData: "No packages here, please create some.",
      noVehiclesSelected: "Please select at least one vehicle.",
      noWheelPart: "Sorry, this package has no wheel part",
      packageCopyNote:
        "To duplicate '{{ packageName }}', we'll create a new quote where you can make any necessary changes.",
      packageCreated: "Package created",
      packageDeleteNote:
        "You are about to permanently delete the package: '{{ packageName }}'",

      packageDeleted: "Package deleted",
      packageDescription: "Package Description",
      packageDescriptionFr: "Package Description (French)",
      packageEditor: "Package Editor",
      packageExpireDate: "Expire Date",
      packageImage: "Package Image",
      packageName: "Package Name",
      packageNumber: "Package Number",
      packagePrice: "Package Price",
      packageReleaseDate: "Release Date",
      "part#": "Part #",
      partNumber: "Part Number",
      partType: "Part Type",
      parts: "Parts",
      price: "Price",
      quantity: "Quantity",
      quoteTotal: "Quote Total",
      selectAllVehicles: "All",
      selectNoneVehicles: "None",
      selectVehicleYears: "Select Vehicle Years and Manufacturers",
      selected: "Selected",
      showParts: "Show Parts",
      typeName: "Type",
      updatePackage: "Update Package",
      vehicles: "Vehicles",
    },
    pageNotFound: "Page Not Found",
    priceSelect: {
      front: "Front",
      price: "Price",
      quantity: "Quantity",
      rear: "Rear",
      savings: "Savings",
      total: "Part Total",
    },
    pricingAnalysis: {
      allBrands: "All Brands",
      averagePrice: "Average Price",
      brand: "Brand",
      costPrice: "Cost Price",
      header: "Tire Pricing Analysis",
      minPrice: "Min Price",
      name: "Name",
      noData: "Sorry, your search was unable to find any results.",
      openCMS: "Login to update pricing",
      partNumber: "Part #",
      quantityBooked: "Quantity Booked",
      quantitySold: "Quantity Sold",
      search: "Search",
      summary: "Summary",
      summaryHigherThen: "{{val}} higher than minimum price",
      summaryLowerThen: "{{val}} lower than minimum price",
      tireSize: "Tire Size",
      yourPrice: "Your Price",
    },
    provinceSelect: {
      AB: "Alberta",
      BC: "British Columbia",
      MB: "Manitoba",
      NB: "New Brunswick",
      NL: "Newfoundland and Labrador",
      NS: "Nova Scotia",
      NT: "Northwest Territories",
      NU: "Nunavut",
      ON: "Ontario",
      PE: "Prince Edward Island",
      QC: "Québec",
      SK: "Saskatchewan",
      YT: "Yukon",
      viewAll: "Any Province",
    },
    quoteReport: {
      createdBy: "Created By",
      customerEmail: "Customer Email",
      customerName: "Customer Name",
      customerNotes: "Notes",
      customerPhone: "Customer Phone",
      dateCreated: "Date Created (Updated)",
      details: "Details",
      isDealer: "DLR",
      isNational: "NTL",
      noData: "Sorry, your search was unable to find any results.",
      notAvailable: "N/A",
      orderPrinted: "Order Printed",
      priceMatch: "Price Match",
      quoteNumber: "Quote #",
      quoteTotal: "Quote Total",
      status: "Order Status",
      type: "Type",
      viewQuotes: "View Quote",
      yes: "Yes",
    },
    searchForm: {
      chassis: "Chassis",
      enterPartNumber: "Enter Part Number",
      enterPostalCode: "Enter Postal Code",
      enterTireSize: "Enter Tire Size",
      partNubmer: "Part #",
      searchByPartNubmer: "Search by Part #",
      searchByTireSize: "Search by Tire Size",
      searchByVehicle: "Search by Vehicle",
      selectLocation: "Select Location",
      selectMake: "Select Make",
      selectModel: "Select Model",
      selectProductType: "Select Product Type",
      selectTrim: "Select Trim",
      selectYear: "Select Year",
      tireSize: "Tire Size",
      vehicle: "Vehicle",
      vehicleChassisPlaceholder: "w204 or w204.012",
      viewResults: "View Results",
    },
    searchResults: {
      accessoryHint: "Here are some accessories for your car",
      axiePartner: "Axie Partner",
      backToContact: "Back to Contact",
      backToQuote: "Back to Quote",
      backToResults: "Back to Results",
      categories: "Categories",
      checkNationalStock: "Check",
      checkNationalStockFront: "Front",
      checkNationalStockRear: "Rear",
      color: "Color",
      contactDealer: "Contact Dealer",
      contactMethod: "Please contact me via",
      dealerFormDescription:
        "Please leave your contact information here so that we can get back to you soon.",
      description: "Description",
      diameter: "Diameter",
      email: "Email",
      filters: "Filters",
      filtersSubtitle: "Select & apply the descried filters",
      front: "Front",
      installation: "Installation",
      installationRequired: "Installation Required",
      leadSuccessHeading: "Thank You for Reaching Out!",
      leadSuccessMessage:
        "Your information has been successfully submitted. We'll get back to you as soon as we can. Thank you for your interest!",
      loadSpeedPly: "Load/Speed/Ply",
      msrp: "MSRP",
      nationalStock: "National Stock",
      no: "No",
      noData: "No results found, try a different vehicle or size.",
      noSeasons: "Seasons not available",
      notes: "Notes",
      offset: "Offset",
      openInNewWindow: "Open in New Window",
      originalEquipment: "Original Equipment",
      originalEquipmentAll: "Show All",
      originalEquipmentOnly: "Show Only Original Equipment",
      packageOptions: "Package Options ",
      packageResultsLink: "See Available Tire Packages",
      partDetails: "Part Details",
      partNumber: "Part #",
      price: "Price",
      pricing: "Pricing",
      pricingIsNotAvailable:
        "Pricing is not available for this search. Please contact dealer for pricing.",
      pricingNote: "Pricing note",
      rear: "Rear",
      reccommendedFor: "Recommended For",
      relatedParts: "Related Parts",
      requestMoreInformation: "Request More Information",
      requiresInstallation: "Requires Installation",
      restrictions: "Restrictions",
      runFlat: "Run Flat",
      search: "Search",
      season: "Season",
      selectWeelToPreview: "Select a wheel to preview",
      sendRequest: "Send Request",
      showNonRunFlat: "Show Non Run Flat",
      showRunFlat: "Show Run Flat",
      size: "Size",
      tel: "Phone",
      tire: "Tire",
      tireBrand: "Tire Brand",
      tireLoadRating: "Load Rating",
      tirePlyRating: "Ply Rating / LT Rating",
      tireSize: "Tire Size",
      tireSpeedIndex: "Speed Index",
      viewDetails: "View Details",
      warning: "Warning",
      warranty: "Warranty",
      wheel: "Wheel",
      wheelBrand: "Wheel Brand",
      wheelVisualizerCaution: "Vehicle may not appear exactly as shown",
      wheelVisualizerHint:
        "You can customize the color of the car & select a wheel to preview",
      width: "Width",
      yes: "Yes",
      youChoose: "You Choose",
      yourPersonalizedQuote: "Your Personalized Quote",
    },
    season: {
      "0": "Winter",
      "1": "All Season",
      "2": "Summer",
    },
    siteHeader: {
      bookinkSystem: "Booking System",
      cmsUrl: "CMS URL",
      contactUs: "Contact Us",
      home: "Home",
      howToVideos: "How To Videos",
      nationalSite: "Change Location",
      pricingAnalysis: "Tire Pricing Analysis",
      signIn: "Sign In",
      signOut: "Sign Out",
    },
    sizeTypeDescription: {
      "Alternate Size": "Alternate Size",
      "Down Size": "Down Size",
      "Original Size": "Original Size",
      "Seasonal Size": "Seasonal Size",
      "Temporary Size": "Temporary Size",
      "Up Size": "Up Size",
    },
    stockLevelsModal: {
      city: "City",
      distributor: "Distributor",
      lastUpdated: "Last Updated",
      location: "Location",
      phone: "Phone",
      province: "Province",
      qty: "Quantity",
    },
    tireSizeDiagram: {
      description:
        "To ensure proper sizing always contact your local vehicle service center.",
      subtitle: "How to find your tire size",
      title: "Tire Size Diagram",
    },
    tireSizeInput: {
      price: "Price",
      quantity: "Quantity",
      total: "Total",
    },
    toast: {
      [ToastTypeError]: "Error",
      [ToastTypeInfo]: "Info",
      sessionExpired: "Your session has expired. Please sign in again.",
    },
  },
};

export type Translations = typeof en;
